
(function () {
  'use strict';

  const UPSELL_SELECTOR = '#cart-drawer-upsell';

  function initUpsell() {
    const upsellContainer = document.querySelector(UPSELL_SELECTOR);
    if (!upsellContainer) return;

    // Swatch selection
    upsellContainer.querySelectorAll('.cart-drawer-upsell__swatch').forEach((swatch) => {
      swatch.addEventListener('click', handleSwatchClick);
    });

    // Add to Cart buttons
    upsellContainer.querySelectorAll('.cart-drawer-upsell__add-btn').forEach((btn) => {
      btn.addEventListener('click', handleAddToCart);
    });
  }

  function handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const swatchGroup = swatch.closest('.cart-drawer-upsell__swatches');
    const productCard = swatch.closest('.cart-drawer-upsell__product-card');
    const addBtn = productCard.querySelector('.cart-drawer-upsell__add-btn');

    // Update active state
    swatchGroup.querySelectorAll('.cart-drawer-upsell__swatch').forEach((s) => {
      s.classList.remove('cart-drawer-upsell__swatch--active');
    });
    swatch.classList.add('cart-drawer-upsell__swatch--active');

    // Update the variant ID on the Add to Cart button
    addBtn.dataset.selectedVariantId = swatch.dataset.variantId;
  }

  function handleAddToCart(event) {
    const btn = event.currentTarget;
    const variantId = btn.dataset.selectedVariantId;

    if (!variantId) return;

    // Disable button and show loading state
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    const body = JSON.stringify({
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
        },
      ],
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(() => {
        // Refresh the cart drawer contents by fetching the updated cart-drawer section
        return fetch('/?section_id=cart-drawer');
      })
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        // Update cart drawer inner content
        const newDrawerInner = parsedHTML.querySelector('.drawer__inner');
        const currentDrawerInner = document.querySelector('.drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        // Update cart icon bubble count
        fetch('/?section_id=cart-icon-bubble')
          .then((r) => r.text())
          .then((bubbleHtml) => {
            const bubbleParsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            const newBubble = bubbleParsed.querySelector('.shopify-section');
            const currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          });

        // Re-initialize upsell event listeners (content was replaced)
        initUpsell();

        // Re-bind the overlay close listener
        const overlay = document.querySelector('#CartDrawer-Overlay');
        const cartDrawer = document.querySelector('cart-drawer');
        if (overlay && cartDrawer) {
          overlay.addEventListener('click', () => cartDrawer.close());
        }

        // Publish cart update event if pub/sub is available
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
        }
      })
      .catch((error) => {
        console.error('Cart drawer upsell error:', error);
        btn.textContent = 'Error — try again';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsell);
  } else {
    initUpsell();
  }

  // Re-initialize when the cart drawer is updated (e.g., after adding/removing items)
  // This uses a MutationObserver on the cart drawer to catch content swaps
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Small delay to ensure DOM is settled
        setTimeout(initUpsell, 100);
        break;
      }
    }
  });

  const drawerInner = document.querySelector('.drawer__inner');
  if (drawerInner) {
    observer.observe(drawerInner, { childList: true, subtree: true });
  }
})();
